import React, { memo } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getIsBannerVisible } from '@app/redux/ui/selectors';
import { Button } from '@stockx/ui';
import { config } from '@app/config';

const {
  SERVICES: { HYPERWALLET },
} = config;

const styles = {
  bg: 'green.700',
  color: 'neutral.white',
  textTransform: 'uppercase',
  borderRadius: '0',
  _hover: {
    bg: 'green.700',
  },
};

const HyperwalletNag = ({ isBannerOpen }) => {
  const { t } = useTranslation();

  if (!isBannerOpen) {
    return null;
  }

  return (
    <a
      href={HYPERWALLET.URL}
      target="_blank"
      rel="noopener noreferrer"
      data-component="HyperwalletNag"
    >
      <Button sx={styles} width={'100%'}>
        {t('hyperwallet_nag_banner')}
      </Button>
    </a>
  );
};

const mapStateToProps = (state) => ({
  isBannerOpen: getIsBannerVisible(state, 'hyperwallet'),
});

export default connect(mapStateToProps)(memo(HyperwalletNag));
